module.exports = __WEBPACK_EXTERNAL_MODULE__ontotext_root_config_3c500dad__;